<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="smiley">
            <defs>
                <path id="a6u0d8mdka" d="M8 0c4.397 0 8 3.569 8 8.021 0 4.143-3.176 7.543-7.201 7.943v1.677h2.177c.458 0 .795.377.795.797 0 .42-.376.797-.795.797H5.024c-.419 0-.795-.377-.795-.797 0-.42.376-.797.795-.797h2.181v-1.677C3.175 15.568 0 12.164 0 7.982 0 3.612 3.603 0 8 0zm0 1.598c-3.516 0-6.367 2.854-6.367 6.384 0 3.526 2.85 6.384 6.367 6.384 3.516 0 6.367-2.854 6.367-6.384 0-3.486-2.85-6.384-6.367-6.384zm.044 2.249c2.262 0 4.109 1.843 4.109 4.11 0 2.305-1.843 4.109-4.11 4.109-2.266 0-4.109-1.847-4.109-4.11 0-2.262 1.843-4.109 4.11-4.109zm0 1.635c-1.384 0-2.474 1.133-2.474 2.474 0 1.384 1.133 2.474 2.474 2.474 1.384 0 2.474-1.133 2.474-2.474 0-1.34-1.09-2.474-2.474-2.474z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <g transform="translate(4 2)">
                    <mask id="0vrfxgskob" fill="#fff">
                        <use xlink:href="#a6u0d8mdka"/>
                    </mask>
                    <use fill="#000" fill-rule="nonzero" xlink:href="#a6u0d8mdka"/>
                    <g class="path" :fill="fill" mask="url(#0vrfxgskob)">
                        <path :d="`M0 0H${height}V${width}H0z`" transform="translate(-4 -2)"/>
                    </g>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-smiley',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>